import React from 'react';

import { GenderDistributionChartBase } from '../base/GenderDistributionChartBase';

export const GenderDistributionChart = props => {
  const { data } = props;

  return (
    <GenderDistributionChartBase data={data} />
  );
};
